import { Box, theme, Typography, UnorderedList } from '@fe-toolkit/web-components'

const LearnMoreAboutHomeInstallModalContent = () => {
  return (
    <Box>
      <Typography as="h2" sx={{ marginBottom: theme.spacing.small }} variant="louder">
        Home install
      </Typography>
      <Typography as="p" sx={{ marginBottom: theme.spacing.small, fontWeight: '300' }} variant="speak">
        This is the final step, and you're live.
      </Typography>

      <UnorderedList withBullets>
        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          The engineers will come by and bring the fibre cable from the street to your house. Either through existing
          ducts or by laying a new cable.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          You need to be there for the whole visit. It'll take about an hour.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          Our engineer will bring the fibre cable into your home. Either through an existing hole or they'll drill one.
        </Typography>
        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          They'll attach a box to the inside wall that converts the fibre signals for your router. This needs to be a
          spot with two power plugs, one for the fibre box and one for the router.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          Then they'll plug in your router, do a speed test and you'll be all sorted.
        </Typography>
      </UnorderedList>

      <Typography sx={{ fontWeight: '300' }} variant="speak">
        Your install is in good hands with the expert engineers from our partners at Virgin Media. They'll help you get
        the most out of your new fibre setup.
      </Typography>
    </Box>
  )
}

export default LearnMoreAboutHomeInstallModalContent
